module.exports = __webpack_public_path__ + "static/media/icon_ceramic_metal_3.f5ae195d.svg";